import { Controller } from '@hotwired/stimulus'
import IMask from 'imask'
import visaImg from '../images/card-brands/visa.svg?raw'
import mastercardImg from '../images/card-brands/mastercard.svg?raw'
import amexImg from '../images/card-brands/amex.svg?raw'
import dinersImg from '../images/card-brands/diners.svg?raw'
import eloImg from '../images/card-brands/elo.svg?raw'
import hipercardImg from '../images/card-brands/hipercard.svg?raw'

export default class extends Controller {
  static targets = ['input']
  static values = { type: String }

  connect() {
    const masks = {
      cpf: { mask: '000.000.000-00' },
      zipCode: { mask: '00000-000' },
      phone: {
        mask: [
          { mask: '(00) 0000-0000' },
          { mask: '(00) 00000-0000' }
        ]
      },
      creditCard: { mask: '0000 0000 0000 0000' },
      expiry: { mask: '00/00' },
      cvv: { mask: '0000' },
    }

    if (masks[this.typeValue]) {
      IMask(this.element, masks[this.typeValue])
    }

    if (this.typeValue === 'creditCard') {
      this.detectCardBrand()
      this.element.addEventListener('input', this.detectCardBrand.bind(this))
    }
  }

  detectCardBrand() {
    const number = this.element.value.replace(/\s/g, '')
    const brand = this.getCardBrand(number)
    this.updateCardBrand(brand)
  }

  getCardBrand(number) {
    const patterns = {
      elo: /^(4011|4312|4389|4514|4573|4576|5041|5066|5067|5090|6277|6362|6500|6504|6505|6507|6509|6516|6529|6550)/,
      amex: /^(34|37)/,
      diners: /^(30[0-5]|36|38)/,
      hipercard: /^(606282|3841|60)/,
      mastercard: /^(5[1-5]|22[2-9]|2[3-6]\d|27[01]\d|2720)/,
      visa: /^4/
    }

    for (const [brand, regex] of Object.entries(patterns)) {
      if (regex.test(number)) return brand
    }

    return 'unknown'
  }

  updateCardBrand(brand) {
    const images = {
      visa: visaImg,
      mastercard: mastercardImg,
      amex: amexImg,
      diners: dinersImg,
      elo: eloImg,
      hipercard: hipercardImg,
    }
    const src = images[brand]
    let element = this.element.parentNode.querySelector('.card-brand')

    if (brand === 'unknown') {
      element?.remove()
      return
    }

    if (!element) {
      element = document.createElement('div')
      element.className = 'card-brand absolute right-3 top-1/2 -translate-y-1/2 h-8'
      this.element.parentNode.appendChild(element)
    }

    element.innerHTML = src
    element.querySelector('svg').style.height = '100%'
    element.querySelector('svg').style.width = 'auto'
  }
}
